export function PrismaIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="47" 
        height="56" 
        viewBox="0 0 47 56" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M46.0683 42.664L26.8102 1.76651C26.3227 0.741121 25.3122 0.0655366 24.1784 0.00686126C23.0419 -0.0692841 21.9574 0.492932 21.3646 1.46554L0.477012 35.2964C-0.171434 36.3393 -0.157791 37.6632 0.512009 38.6926L10.7241 54.507C11.5176 55.7262 13.0185 56.2781 14.4128 55.8635L44.0483 47.0974C44.9511 46.8335 45.6951 46.1911 46.0879 45.3364C46.4753 44.4858 46.4687 43.5078 46.0697 42.6626L46.0683 42.664ZM41.7567 44.4181L16.6092 51.8542C15.8421 52.0824 15.1058 51.4175 15.2653 50.6433L24.2498 7.62361C24.4178 6.81868 25.5293 6.69129 25.8806 7.43603L42.5126 42.755C42.6614 43.0735 42.6632 43.4413 42.5175 43.7612C42.3718 44.0812 42.0932 44.3212 41.7553 44.4181H41.7567Z" 
          fill="#F2F2F2" 
        />
      </svg>
    )
  }